var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-wrapper",class:{ 'is-loaded': _vm.isLoaded }},[(!_vm.isLoaded)?_c('div',{staticClass:"image-placeholder"},[_c('div',{staticClass:"loading-spinner"})]):_vm._e(),_c('img',{class:{ 'fade-in': _vm.isLoaded },attrs:{"src":_vm.src,"alt":_vm.alt},on:{"load":_vm.onImageLoad}})])
}
var staticRenderFns = []

export { render, staticRenderFns }